import * as yup from 'yup';
import { FieldValidator } from '../../types';

export const validator: FieldValidator = (_, t) =>
  yup.object({
    tiers: yup.array(),
  });
